// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2A6gY","ranges":"BmiRanges_ranges__VEzPk"};